import AddFavorite from 'assets/icons/AddFavorite';
import Bookmark from 'assets/icons/Bookmark';
import InlineLoader from 'common/components/InlineLoader';
import { cn } from 'common/utils';
import React from 'react';

const FavoriteToggle = ({
  favoriteStatus,
  setFavoriteStatus,
  isFavoriteStatusChanging,
}) => {
  const toggleFavorite = () => {
    if (isFavoriteStatusChanging) return;
    const newFavoriteStatusValue = !favoriteStatus;
    setFavoriteStatus(newFavoriteStatusValue);
  };

  return (
    <div className='flex items-center justify-center flex-nowrap gap-1'>
      <button
        onClick={toggleFavorite}
        aria-disabled={isFavoriteStatusChanging}
        disabled={isFavoriteStatusChanging}
        className={cn(
          'flex items-center',
          isFavoriteStatusChanging ? 'cursor-not-allowed opacity-50' : '',
        )}
      >
        {favoriteStatus ? (
          <Bookmark color='#f16347' size='24' fillColor='#f16347' />
        ) : (
          <AddFavorite size='24' />
        )}
      </button>
      {isFavoriteStatusChanging ? (
        <div className='flex items-center justify-center flex-shrink-0'>
          <InlineLoader size='20' />
        </div>
      ) : (
        <div
          className='opacity-0 pointer-events-none flex-shrink-0'
          aria-hidden='true'
        >
          <InlineLoader size='20' />
        </div>
      )}
    </div>
  );
};

export default FavoriteToggle;
